import { Link } from 'react-router-dom';

const localServices = [
  {
    icon: 'ri-building-line',
    title: 'Asbestos Abatement',
    desc: 'Certified asbestos inspection, testing, and removal for Colorado Springs commercial buildings, schools, and industrial facilities.',
    img: 'https://public.readdy.ai/ai/img_res/6a410f66a94d09ff7898df08bdcee44d.jpg',
  },
  {
    icon: 'ri-drop-line',
    title: 'Mold Remediation',
    desc: 'Complete mold assessment and certified removal restoring safe environments in Colorado Springs homes, businesses, and government buildings.',
    img: 'https://readdy.ai/api/search-image?query=mold%20remediation%20specialist%20treating%20heavy%20black%20mold%20and%20water%20damage%20on%20flooded%20basement%20concrete%20block%20wall%20using%20industrial%20sprayer%20with%20antifungal%20solution%20protective%20suit%20gloves%20respirator%20industrial%20dehumidifiers%20running%20dramatic%20interior%20work%20lighting%20professional%20Colorado%20home%20restoration%20documentary%20photography%20dark%20tones&width=500&height=360&seq=ecos-cos-svc3-002&orientation=landscape',
  },
  {
    icon: 'ri-alert-line',
    title: 'Disaster Restoration',
    desc: '24/7 emergency response for flood, fire, and contamination events throughout Colorado Springs and El Paso County.',
    img: 'https://readdy.ai/api/search-image?query=disaster%20restoration%20emergency%20water%20damage%20crew%20inside%20flooded%20commercial%20office%20building%20using%20truck-mounted%20water%20extraction%20machine%20industrial%20air%20movers%20and%20dehumidifiers%20drying%20soaked%20carpet%20and%20flooring%20professional%20crew%20in%20safety%20gear%20emergency%20lighting%20dramatic%20cinematic%20photography%20urgent%20restoration%20Colorado%20Springs%20dark%20muted%20tones&width=500&height=360&seq=ecos-cos-svc3-003&orientation=landscape',
  },
  {
    icon: 'ri-flask-line',
    title: 'Hazardous Material Removal',
    desc: 'Licensed hazardous material handling and disposal for Colorado Springs industrial sites, military contractors, and commercial properties.',
    img: 'https://readdy.ai/api/search-image?query=hazardous%20material%20removal%20certified%20worker%20in%20orange%20hazmat%20suit%20with%20full%20face%20respirator%20carefully%20handling%20and%20packaging%20hazardous%20chemical%20waste%20containers%20inside%20commercial%20facility%20containment%20zone%20caution%20signage%20professional%20industrial%20lighting%20environmental%20compliance%20safety%20work%20documentary%20style%20muted%20earth%20tones%20Colorado&width=500&height=360&seq=ecos-cos-svc3-004&orientation=landscape',
  },
];

export default function ColoradoSpringsServicesOverview() {
  return (
    <section className="bg-white py-28">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16 items-end">
          <div className="lg:col-span-6">
            <p className="text-ecos-green text-xs uppercase tracking-widest font-semibold mb-4">Colorado Springs Services</p>
            <h2 className="font-serif text-ecos-charcoal text-4xl lg:text-5xl font-semibold leading-tight">
              Certified Environmental Services Across Colorado Springs
            </h2>
          </div>
          <div className="lg:col-span-6 flex flex-col items-start lg:items-end gap-4">
            <p className="text-ecos-text text-base leading-relaxed lg:text-right max-w-md">
              ECOS Environmental maintains certified response teams serving Colorado Springs, El Paso County, and the surrounding Front Range for all environmental remediation needs.
            </p>
            <Link
              to="/services/asbestos-abatement"
              className="inline-flex items-center gap-2 border border-ecos-green text-ecos-green hover:bg-ecos-green hover:text-white font-medium text-sm px-6 py-3 rounded-sm transition-colors cursor-pointer whitespace-nowrap"
            >
              All Services
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm"></i>
              </div>
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {localServices.map((svc) => (
            <Link
              key={svc.title}
              to="/services/asbestos-abatement"
              className="group block border border-ecos-border rounded-sm overflow-hidden hover:border-ecos-green transition-all duration-300 cursor-pointer hover:-translate-y-1"
            >
              <div className="w-full h-48 overflow-hidden relative">
                <img
                  src={svc.img}
                  alt={`${svc.title} Colorado Springs — ECOS Environmental`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-9 h-9 flex items-center justify-center bg-ecos-green-pale rounded-sm flex-shrink-0">
                    <i className={`${svc.icon} text-ecos-green text-base`}></i>
                  </div>
                  <h3 className="font-serif text-ecos-charcoal text-base font-semibold group-hover:text-ecos-green transition-colors leading-snug">{svc.title}</h3>
                </div>
                <p className="text-ecos-text text-sm leading-relaxed">{svc.desc}</p>
              </div>
            </Link>
          ))}
        </div>

      </div>
    </section>
  );
}
